import React from 'react';
import { UploadFile } from 'antd/es/upload/interface';
import { CCSRFToken } from 'libs/api/apiClient';
import { ECurrencyType, EQuestionCategory } from 'enums/base.enum';

export const CWindowWidth = 1440;
export const CQuestionCategory = {
  [EQuestionCategory.SignIn]: '회원가입',
  [EQuestionCategory.Mentoring]: '멘토링',
  [EQuestionCategory.Program]: '프로그램',
  [EQuestionCategory.Content]: 'Content',
  [EQuestionCategory.Voucher]: '수강권',
  [EQuestionCategory.Tech]: '기술문제',
  [EQuestionCategory.ETC]: '기타',
};
export const CCurrencyList = {
  [ECurrencyType.KRW]: 'KRW',
  [ECurrencyType.USD]: 'USD',
  [ECurrencyType.SGD]: 'SGD',
  [ECurrencyType.INR]: 'INR',
  [ECurrencyType.VND]: 'VND',
  [ECurrencyType.IDR]: 'IDR',
  [ECurrencyType.MYR]: 'MYR',
  [ECurrencyType.CNY]: 'CNY',
  [ECurrencyType.JPY]: 'JPY',
};

export const CCurrencyTypeByLanguage = {
  'en-US': 'USD',
  'ko-KR': 'KRW',
};

export const CDayOfWeek = {
  0: '일',
  1: '월',
  2: '화',
  3: '수',
  4: '목',
  5: '금',
  6: '토',
};
export const CDayOfWeekFieldName = {
  0: 'sunday',
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday',
};

export const CDefaultEditorHeight = 700;
export const CDefaultEditorPlugins = [
  'preview advlist autolink lists link image charmap hr anchor pagebreak',
  'searchreplace',
  'insertdatetime nonbreaking save table contextmenu directionality',
  'emoticons paste textcolor colorpicker textpattern',
  'media',
];
export const CDefaultEditorToolbars =
  'insertfile undo redo | styleselect | fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | link image preview | media';
export const CDefaultDateTimeFormat = 'YYYY-MM-DD HH:mm';
export const CDefaultDateFormat = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY/MM/DD'];
export const CMaxFileSize = '50MB';
export const CUploadFileProps = {
  withCredentials: true,
  headers: {
    accept: 'application/json',
    'X-CSRFToken': window.localStorage.getItem(CCSRFToken) || '',
  },
  showUploadList: {
    showDownloadIcon: false,
  },
};
export const CUploadImageProps = {
  withCredentials: true,
  showUploadList: false,
  headers: {
    accept: 'application/json',
    'X-CSRFToken': window.localStorage.getItem(CCSRFToken) || '',
  },
  listType: 'picture-card' as 'picture-card',
  onPreview: async (file: UploadFile) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as Blob);
        reader.onload = () => resolve(reader.result as string);
      });
    }
    const image = new Image();
    image.src = src as string;
    const imgWindow = window.open(src);
    imgWindow?.document?.write(image.outerHTML);
  },
};
export const CAdminCall = '070-7537-1611';
export const CBusinessName = '(주)빅스텝에듀케이션';
export const CRegistrationNumber = '208-81-30524';
export const CBusinessNumber = '제 2021-서울서초-0929호';
export const CChiefExecutive = '문희성';
export const CAddress = '서울특별시 강남구 도산대로1길 6 4층 A호';
export const CEmail = 'cs@bigstepedu.com';
export const CAdminEmail = 'admin@bigstepedu.com';
export const CDateFormat = 'YYYY-MM-DD';
export const CDateTimeFormat = 'YYYY.MM.DD, A h:mm';
export const CMonthFormat = 'YYYY-MM';
export const CBigstepIntroduction = 'https://bigstepedu.notion.site/e0ee43d5adb949f180c92ee89ea8416b';
export const CBigstepMentoringGuide = 'https://www.notion.so/bigstepedu/630d124f3ab74562a6a0b7026ab04d82';
export const CRefundInformation = 'https://www.notion.so/bigstepedu/0af0f2a2eea3484d9b20d4fba4730d8b';
export const CHowToBuyCaseNote =
  'https://www.notion.so/bigstepedu/Case-Note-937c8afd59ca46d9bdb05eb9e728fe55';
export const CYoutubeURL = 'https://www.youtube.com/channel/UCgkAO-a21gnukng0vTZefhw';
export const CKakaoTalkURL = 'http://pf.kakao.com/_QxaJxdK';
export const CInstagramURL = 'https://www.instagram.com/bigstepedu';
export const CNotionFAQURL = 'https://www.notion.so/bigstepedu/FAQ-cac1e75fabcc4c88a1ff7cf069efd6d3';
export const CCSLogoImageUrl =
  'https://bigstep-backend-media.s3.ap-northeast-2.amazonaws.com/media/image/2020-11-26/sgpdwqnbtvW3BrPTksIGNvbXBhbnlfbmFtZT1CaWdzdGVwIEVkdWNhdGlvbl0.%EB%B9%85%EC%8A%A4%ED%85%9D%EC%97%90%EB%93%80%EC%BC%80%EC%9D%B4%EC%85%98.jpg';
